import React, { Component } from 'react'
// import { Helmet } from 'react-helmet'
// import GambarPleaseAds from './img/please ads.png'
// import GambarTokopedHampers2 from './img/tokoped_hampers2.jpg'
import { Link } from 'react-router-dom'
// import GambarNastar1 from './img/nastar1.jpg'
// import GambarTopples from './img/topples1.jpg'
// import GambarRokaToples from './img/roka_toples.jpg'

function refreshPage(){
  setTimeout(()=>{
    window.location.reload(false);
  }, 500); 
}

export default class DictsInfo extends Component {
  render() {
    return (
      <div>

        <div className="col-md-3  " style={{backgroundColor: '#afb865b0'}} >
        

          <h3 style={{fontSize: '1.5rem', WebkitTextFillColor:'red', fontFamily: 'DFPOP1-W9'}} 
          className="colorlib-heading text-center">Dict's Info:</h3>
          <hr/>

          <Link to="/codeIgniter-4" className="nav-link" onClick={refreshPage}>
                            <span>CodeIgniter 4</span>
            </Link>
          <br/>
          
            <Link to="/unity-3D" className="nav-link" onClick={refreshPage}>
            <span>Unity 3D</span>
            </Link>
          <br/>
          
            <Link to="/corel-draw" className="nav-link" onClick={refreshPage}>
            <span>Corel Draw X6</span>
            </Link>
          <br/>
          
            <Link to="/microsoft-office-excel-2010" className="nav-link" onClick={refreshPage}>
            <span>Microsoft Office Excel 2010</span>
            </Link>
          <br/>
          
            <Link to="/seputar-aplikasi-android" className="nav-link" onClick={refreshPage}>
            <span>Seputar Aplikasi Android</span>
            </Link>
          <br/>

            <Link to="/pengetahuan-umum" className="nav-link" onClick={refreshPage}>
            <span>Pengetahuan Umum</span>
            </Link>
          
          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
            <div className="row g-0">
              <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                <img src={GambarPleaseAds} width="100%" height="100%" alt="dictionaryplusplus.my.id"/>   
                               
              </div>
            </div>
          </div>
          <br/> */}

          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
            <div className="row g-0">
              <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                <img src={GambarPleaseAds} width="100%" height="100%" alt="dictionaryplusplus.my.id"/>   
                               
              </div>
            </div>
          </div>
          <br/> */}

          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
            <div className="row g-0">
              <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                <img src={GambarNastar1} width="100%" height="100%" alt="Tata Letak Dasar Unity 3D"/>   
                <small><a rel="noreferrer noopener" href="https://tokopedia.link/Mr2ejHeR6ob" target="_blank">Kue Nastar Enak, Kue Nastar lebaran, Kue Nastar wangi, Nastar Premium
               </a>
                <br/>
                Tokopedia</small>                     
              </div>
            </div>
          </div>
          <br/> */}

          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
            <div className="row g-0">
              <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                <img src={GambarTokopedHampers2} width="100%" height="100%" alt="Tata Letak Dasar Unity 3D"/>   
                <small><a rel="noreferrer noopener" href="https://tokopedia.link/7JVcO4JR6ob" target="_blank">Toples Kue Snack Lebaran Wadah Makanan Food Storage Container - 700ml 
                </a>
                <br/>
                Tokopedia</small>                     
              </div>
            </div>
          </div>
          <br/> */}

          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
            <div className="row g-0">
              <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                <img src={GambarTopples} width="100%" height="100%" alt="Tata Letak Dasar Unity 3D"/>   
                <small><a rel="noreferrer noopener" href="https://shope.ee/AJusTRLJeW" target="_blank">Toples kue kering nastar Biggy 500 Gram Mika Kode CT250 / Toples Biggy 500 Gr CT 250 / CT-250
                </a>
                <br/>
                Shopee</small>                     
              </div>
            </div>
          </div>
          <br/> */}

          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
            <div className="row g-0">
              <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                <img src={GambarRokaToples} width="100%" height="100%" alt="Tata Letak Dasar Unity 3D"/>   
                <small><a rel="noreferrer noopener" href="https://shope.ee/8K9sg2AQng" target="_blank">Roka Wafer Ball Toples
                </a>
                <br/>
                Shopee</small>                     
              </div>
            </div>
          </div>
          <br/> */}
            
        </div>

            

          {/* awal */}
          {/* <div className="card mb-3 " style={{backgroundColor: '#e5eea2b0'}}>
                      <div className="row g-0">
                        <div  className="col-md-11 " style={{ margin:'0.7em'}} >
                          <img src={GambarTokopedHampers2} width="100%" height="100%" alt="Tata Letak Dasar Unity 3D"/>   
                          <small><a rel="noreferrer noopener" href="https://code.visualstudio.com/" target="_blank">PARSEL RAMADAN KUE KERING BELLAROSA PAKET DANTE SERIES</a></small>                     
                        </div>

                      

                      </div>
                    </div>
                    <br/> */}
          {/* akhir */}



            {/* <div className="col-md-3 " style={{backgroundColor: '#afb865b0'}} >
                           

                <h3 style={{fontSize: '1.5rem', WebkitTextFillColor:'red', fontFamily: 'DFPOP1-W9'}} 
                className="colorlib-heading text-center">Dicts Info:</h3>
                <hr/>
                
                <div className="col-md  " style={{backgroundColor: 'white'}}>
                  <div className="col">
                    <img src={GambarTokopedHampers1} width="50%" height="50%" alt="Tata Letak Dasar Unity 3D" /> 
                    <p>Sebuah .</p>
                  </div>
                  <div className="col">
                    <p>Sebuah .</p>
                  </div>               
                </div>
                
               
                
                <br/>
            </div> */}

              
        
      </div>
    )
  }
}
